import { render, staticRenderFns } from "./ImportQuestionGroups.vue?vue&type=template&id=17e28130&"
import script from "./ImportQuestionGroups.vue?vue&type=script&lang=js&"
export * from "./ImportQuestionGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports